import React from "react";
import { I18n } from "../../i18n/i18n";

import "@styles/c-unsupportedBrowserVersion.scss";

interface Props { 
  i18n: I18n;
  width?: number;
  height?: number;
}

export const UnsupportedBrowserVersionComponent: React.SFC<Props> = ({ i18n, width, height }) => {
  return (
    <div className="vintom">
      <div
        className="c-unsupportedBrowserVersion"
        style={{
          width: width && `${width}px`,
          height: height && `${height}px`
        }}
      >
        {i18n.unsupportedBrowser}
      </div>
    </div>
  );
};
